import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { ClearinghouseEraItems } from './clearinghouse-era-items';
import { ClearinghouseEras } from './clearinghouse-eras';
import { Clearinghouses } from './clearinghouses';

/**
 * Mirrors the support console's three-level shape:
 *   ""                              clearinghouses
 *   ":clearinghouseId"              that clearinghouse's ERAs
 *   ":clearinghouseId/eras/:eraId"  that ERA's items
 *
 * All three are routed and call the real provider API. If a read answers with an error — for example on an
 * environment the backend has not updated yet — the page names the endpoint that failed instead of showing an
 * empty list (see stores/endpoint-unavailable.ts).
 */
/** The account id lives in the URL, so read it there rather than guessing from the pathname. */
function ClearinghousesListWrapper(): React.ReactElement {
    const { accountId } = useParams<{ accountId: string }>();
    return <Clearinghouses accountId={accountId} />;
}

export function ClearinghousesOutlet(): React.ReactElement {
    return (
        <Routes>
            <Route path="" element={<ClearinghousesListWrapper />} />
            <Route path=":clearinghouseId" element={<ClearinghouseEras />} />
            <Route path=":clearinghouseId/eras/:eraId" element={<ClearinghouseEraItems />} />
        </Routes>
    );
}
